import { render, staticRenderFns } from "./the-created-question.vue?vue&type=template&id=023f407b&"
import script from "./the-created-question.vue?vue&type=script&lang=js&"
export * from "./the-created-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports